import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid green',
      margin: '40px 10px 10px 40px',
      height: '90%',
      width: '75%',
    },
  }),
  { index: 1 },
)

export { useStyles }
